import React from 'react';

import ShareLinkDrawer from './ShareLinkDrawer';
import {
  sharedListUrl,
  useMyCoursesPlayedShare,
  useShareMyCoursesPlayed,
  useStopSharingMyCoursesPlayed,
} from '../../hooks/useCoursesPlayedShare';

// Sharing a member's Courses Played list. Anyone with the link sees their ranked list (first name
// and last initial, profile picture, and each course's rank, name and place) at
// /shared/courses-played/{code}. The drawer itself is ShareLinkDrawer, shared with the profile.

interface ShareCoursesPlayedDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ShareCoursesPlayedDrawer: React.FC<ShareCoursesPlayedDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const { data: shareId, isLoading } = useMyCoursesPlayedShare(isOpen);
  const share = useShareMyCoursesPlayed();
  const stopSharing = useStopSharingMyCoursesPlayed();

  return (
    <ShareLinkDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Share your list"
      shareId={shareId}
      isLoading={isLoading}
      share={share}
      stopSharing={stopSharing}
      buildUrl={sharedListUrl}
      intro="Create a link to your ranked list of courses played. Anyone with the link can see it, without an account."
      whatTheySee="They see your first name and last initial, your profile picture, and each course's rank, name and place. Nothing else about you. You can stop sharing at any time."
      sharedText="Anyone with this link can see your ranked list of courses played."
      nativeShareTitle="My courses played on GolfPlayed"
      stoppedText="Your list is no longer shared."
      inputId="courses-played-share-link"
    />
  );
};

export default ShareCoursesPlayedDrawer;
